import React from 'react';
export const UserInfoBanner = () => {
  return <div className="bg-gray-800 text-white p-6 relative overflow-hidden" data-id="element-1021">
      <div className="relative z-10" data-id="element-1022">
        <h1 className="text-2xl font-bold mb-1" data-id="element-1023">
          Good Afternoon, Jasim Yaqoob Alawadhi
        </h1>
        <p className="text-lg" data-id="element-1024">Welcome to Dwaami</p>
      </div>
      {/* Decorative waves */}
      <div className="absolute inset-0 opacity-20" data-id="element-1025">
        <svg width="100%" height="100%" viewBox="0 0 800 200" preserveAspectRatio="none" data-id="element-1026">
          <path d="M 0 100 Q 200 150 400 100 Q 600 50 800 100 L 800 200 L 0 200 Z" fill="#f97316" data-id="element-1027" />
          <path d="M 0 120 Q 200 80 400 120 Q 600 160 800 120 L 800 200 L 0 200 Z" fill="#f97316" opacity="0.7" data-id="element-1028" />
          <path d="M 0 150 Q 200 100 400 150 Q 600 200 800 150 L 800 200 L 0 200 Z" fill="#f97316" opacity="0.4" data-id="element-1029" />
        </svg>
      </div>
    </div>;
};